var jade = require("/Users/nmd/dev/vsct.info/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<!-- components/auto-import-list/component--><div class=\"row collapse\"><div class=\"medium-12 columns\"><table v-on=\"click: onClick\" v-if=\"table\" class=\"custom_table\"><thead><tr><th>Тип</th><th>Дата</th><th>Номер контейнера</th><th>Транспорт</th><th>Склад</th><th>Заявка</th></tr></thead><tfoot><tr><th v-show=\"!table.length\" colspan=\"6\">Нет информации о заявках</th></tr></tfoot><tbody v-show=\"table.length\"><tr v-repeat=\"table | orderBy number\"><td title=\"{{* type.desc + ' / ' + size.desc }}\"><span data-size=\"{{* size.id }}\" class=\"icon-container {{* type.id + ' ' + 'null' }}\"></span></td><td>{{* date | parseTime 'humanDate' '.' }}</td><td>{{{* number}}}</td><td>{{{* transport}}}</td><td>{{{* sklad}}}</td><td>{{{* number | parseAutoImportLink $data}}}</td></tr></tbody></table></div></div><component is=\"alert\" name=\"auto-import-list\" data-message=\"{{ data.message }}\"></component>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/auto-import-list/component.jade
 ** module id = 47
 ** module chunks = 0
 **/